module.exports = __webpack_public_path__ + "static/media/thomas_schlatter.6dc670a5.jpg";